module.exports = __webpack_public_path__ + "static/media/yitong_zhang.69594e96.png";